// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PredictiveInterventionAttributeResponse } from './predictive-intervention-attribute-response';

/** See com.rev360.pms.api.controller.patient.intervention.PredictiveInterventionAttributesResponse */
/* istanbul ignore next */
@GandalfModel
export class PredictiveInterventionAttributesResponse extends GandalfModelBase {

	@GandalfArray(PredictiveInterventionAttributeResponse)
	attributes!: PredictiveInterventionAttributeResponse[];

	@GandalfProperty({ designType: String })
	name!: string;

	@GandalfProperty({ designType: Number })
	predictiveInterventionId!: number;

}
